import React, { useState } from 'react';

const ContactForm = ({ open, onClose }) => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setError('Te rugăm să completezi numele, emailul și mesajul.');
      return;
    }
    try {
      const formData = new FormData();
      formData.append('name', form.name);
      formData.append('email', form.email);
      formData.append('phone', form.phone);
      formData.append('message', form.message);
      const response = await fetch('/api/contact.php', {
        method: 'POST',
        body: formData
      });
      if (!response.ok) {
        throw new Error('Eroare la trimiterea mesajului.');
      }
      setSubmitted(true);
    } catch (err) {
      setError('Eroare la trimiterea mesajului. Încearcă din nou.');
    }
  };

  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      {/* Wrapper fără blur sau overlay */}
      <div className="fixed bottom-6 right-6 flex items-end justify-end w-auto h-auto pointer-events-auto">
        <div className="bg-white rounded-2xl shadow-2xl max-w-md w-[350px] p-8 relative animate-fade-in">
          <button
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl font-bold"
            onClick={onClose}
            aria-label="Închide"
            type="button"
          >
            ×
          </button>
          {submitted ? (
            <div className="text-center">
              <h2 className="text-2xl font-bold mb-4 text-blue-700">Mulțumim!</h2>
              <p className="text-gray-700 mb-4">Mesajul tău a fost trimis. Te vom contacta în cel mai scurt timp.</p>
              <button
                className="mt-4 bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-6 py-2 rounded-lg font-semibold hover:from-blue-600 hover:to-cyan-700 transition-all"
                onClick={onClose}
              >
                Închide
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <h2 className="text-2xl font-bold mb-6 text-blue-700">Contactează-ne</h2>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Nume*</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 text-black"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Email*</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 text-black"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Telefon</label>
                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 text-black"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Mesaj*</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 h-24 resize-none focus:outline-none focus:ring-2 focus:ring-blue-400 text-black"
                  required
                />
              </div>
              {error && <div className="text-red-500 mb-4 text-sm">{error}</div>}
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-6 py-3 rounded-lg font-semibold hover:from-blue-600 hover:to-cyan-700 transition-all"
              >
                Trimite
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
